import React, { useState, useEffect, useRef, useContext } from 'react';

import useNetwork from '../useNetwork';
import { Modal, OffCanvas } from 'bootstrap';
import { AppDataContext } from "./AppDataContext";

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { useStripe, useElements, PaymentElement     } from '@stripe/react-stripe-js';
import {  AddressElement } from '@stripe/react-stripe-js';
 import { Loader } from './Loader';


export default function Stripe(props) {
    // the button text and callback can be passed in as submitButtonText and onSubmitResults properties
    // if you want an alternate button, pass in a prop named alternateButton with buttonText and onButtonClicked properties.

    //const context = useContext(AppDataContext);
    const { loading, networkError, netRequest } = useNetwork(true);

    const [stripePromise, setStripePromise] = useState(null);
    const [options, setOptions] = useState(null);


    useEffect(() => {
        const setupStripeAccount = async () => {
            const url = 'api/site/StripeSetup';


            const resp = await netRequest(url);

            if (resp.status != 200 || resp.data == null) {
                props.onReady(); //added to hide the parent loader when stripe fails to load.
            } else if (resp.data != null) {
                setStripePromise(loadStripe(resp.data.stripePublishableKey));
                setOptions({
                    // passing the client secret obtained in step 2
                    clientSecret: resp.data.clientSecret
                });
            }
        }


        setupStripeAccount();

    }, []);


    if (loading)
        return <></>


    if (options != null) {


        return (
            <Elements stripe={stripePromise} options={options}>              
                <StripeForm onReady={props.onReady} onSubmitResults={props.onSubmitResults} submitButtonText={props.submitButtonText} alternateButton={props.alternateButton} />
            </Elements>
        );
    }
    return (
        <>Unable to connect to the stripe system</>
    );
}
 

function StripeForm(props) {
    const context = useContext(AppDataContext);

    const [submitting, setSubmitting] = useState(false);

    const stripe = useStripe();
    const elements = useElements();

    const { loading, networkError, netRequest } = useNetwork(false);
    
    const setPaymentMethod = async (event) => {

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }
        setSubmitting(true);
        await stripe.confirmSetup({
            //`Elements` instance that was used to create the Payment Element
            elements,
            confirmParams: {
                return_url: window.location.toString(),
            }
            , redirect: "if_required"

        }).then(async function (result) {
            setSubmitting(false);
            if (result.error) {
                // Inform the customer that there was an error.
                props.onSubmitResults({ isError: true, errorMessage: result.error.message });
            } else {
                switch (result.setupIntent.status) {
                    case 'succeeded':
                        if (result.setupIntent.payment_method != null) {

                            //save the payment method

                            const url = 'api/site/StripeSetPaymentMethod';

                            const resp = await netRequest(url, { paymentMethodId: result.setupIntent.payment_method });

                            if (resp.isError) {
                                props.onSubmitResults({ isError: true, errorMessage: "An unexpected error occurred" });
                            } else {
                                props.onSubmitResults(resp);
                            }
                        }
                        break;

                    case 'processing':
                        props.onSubmitResults({ isError: true, errorMessage: "Processing payment details. We'll update you when processing is complete" });
                        break;

                    case 'requires_payment_method':
                        // Redirect your user back to your payment page to attempt collecting
                        // payment again
                        props.onSubmitResults({ isError: true, errorMessage: "Failed to process payment details. Please try another payment method" });
                        break;
                }
                
            }
        });


    };


    return (
        <>
         <Loader loading={submitting || loading} />
        <form>
                

             
          
                <PaymentElement onReady={props.onReady} />
                <AddressElement options={{
                    mode: 'billing',
                    defaultValues: {
                        name: context.fullName                        
                    },


                }} />

            {props.alternateButton &&
                <button type="button" class="btn btn-primary btn-sm m-2" onClick={props.alternateButton.onButtonClicked}>{props.alternateButton.buttonText}</button>
            }
            <button type="button" class="btn btn-primary btn-sm m-2" onClick={setPaymentMethod}>{props.submitButtonText ?? "Submit"}</button>
            </form>
            </>
    );
}